import { render, staticRenderFns } from "./toConsultingService.vue?vue&type=template&id=14042ffe&scoped=true&"
import script from "./toConsultingService.vue?vue&type=script&lang=js&"
export * from "./toConsultingService.vue?vue&type=script&lang=js&"
import style0 from "./toConsultingService.vue?vue&type=style&index=0&id=14042ffe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14042ffe",
  null
  
)

export default component.exports